<script lang="ts">
  import type { Snippet } from "svelte";

  interface Props {
    status?: string;
    variant?: "default" | "success" | "warning" | "danger" | "info";
    class?: string;
    children?: Snippet;
  }

  const { status = "", variant, class: extraClass = "", children }: Props = $props();

  const variantClass = $derived.by(() => {
    if (variant) {
      return `badge-${variant}`;
    }
    switch (status) {
      case "running":
      case "online":
      case "ready":
        return "badge-success";
      case "starting":
      case "stopping":
      case "queued_install":
      case "queued_start":
      case "queued_stop":
      case "queued_delete":
      case "installing":
      case "draining":
        return "badge-warning";
      case "stopped":
      case "offline":
      case "failed":
      case "deleting":
      case "disabled":
        return "badge-danger";
      default:
        return "badge-default";
    }
  });
</script>

<span class="badge {variantClass} {extraClass}">
  <span class="badge-dot" aria-hidden="true"></span>
  <span class="badge-content">
    {@render children?.()}
  </span>
</span>

<style>
  .badge {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.68rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    line-height: 1;
    padding: 0.25rem 0.55rem;
    border-radius: 9999px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
  }

  .badge-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
  }

  .badge-success {
    color: var(--green, #2ecc71);
    background: rgba(46, 204, 113, 0.1);
    border-color: rgba(46, 204, 113, 0.25);
  }

  .badge-warning {
    color: var(--amber, #f39c12);
    background: rgba(243, 156, 18, 0.1);
    border-color: rgba(243, 156, 18, 0.25);
  }

  .badge-danger {
    color: var(--mars-light, #ff6b4a);
    background: rgba(255, 107, 74, 0.1);
    border-color: rgba(255, 107, 74, 0.25);
  }

  .badge-info {
    color: var(--blue, #3498db);
    background: rgba(52, 152, 219, 0.1);
    border-color: rgba(52, 152, 219, 0.25);
  }

  .badge-default {
    color: var(--dim, #a0a0a0);
  }
</style>
